// extracted by mini-css-extract-plugin
export var sectionwrapper = "TopicPage-module--sectionwrapper--ae179";